import { render, staticRenderFns } from "./NotificationCircle.vue?vue&type=template&id=cddf86de&scoped=true&"
import script from "./NotificationCircle.vue?vue&type=script&lang=js&"
export * from "./NotificationCircle.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCircle.vue?vue&type=style&index=0&id=cddf86de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddf86de",
  null
  
)

export default component.exports